/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssessmentWithRelations } from './assessmentWithRelations';
import { AssessmentParticipantWithRelations } from './assessmentParticipantWithRelations';
import { QuestionAnswerWithRelations } from './questionAnswerWithRelations';
import { UserWithRelations } from './userWithRelations';


/**
 * (tsType: AssessmentResponseWithRelations, schemaOptions: { includeRelations: true })
 */
export interface AssessmentResponseWithRelations { 
    id?: string;
    sessionId?: string;
    status: string;
    startedOn: string;
    completedOn?: string;
    ipAddress?: string;
    userAgent?: string;
    assessmentId: string;
    participantId?: string;
    userId?: number;
    assessment?: AssessmentWithRelations;
    participant?: AssessmentParticipantWithRelations;
    user?: UserWithRelations;
    answers?: Array<QuestionAnswerWithRelations>;
}

